var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, FormControlLabel, FormGroup, List, ListItem, ListSubheader, TextField, styled } from '@mui/material';
import groupBy from 'lodash/groupBy';
import React, { useMemo, useState } from 'react';
import { getUnassignedLOB, sortByLOBName } from '../autocomplete/group';
var StyledList = styled(List)(function (_a) {
  var theme = _a.theme;
  return {
    minHeight: '10.375rem',
    maxHeight: '10.375rem',
    border: '1px solid',
    borderColor: theme.palette.grey[700],
    overflowY: 'scroll',
    padding: theme.spacing(1)
  };
});
var StyledFormControlLabel = styled(FormControlLabel)(function () {
  return {
    marginLeft: 'unset'
  };
});
var StyledCheckbox = styled(Checkbox)(function (_a) {
  var theme = _a.theme;
  return {
    padding: theme.spacing(1)
  };
});
var LobListSubheader = styled(ListSubheader)(function (_a) {
  var theme = _a.theme;
  return {
    backgroundColor: theme.palette.background.default,
    fontWeight: 600,
    paddingLeft: theme.spacing(2),
    minHeight: 32,
    lineHeight: '32px'
  };
});
export var QueueCheckboxGroup = React.memo(function (_a) {
  var options = _a.options,
    value = _a.value,
    onChange = _a.onChange,
    maxSelected = _a.maxSelected,
    labels = _a.labels,
    ariaLabel = _a.ariaLabel,
    disabled = _a.disabled;
  var _b = useState(''),
    searchTerm = _b[0],
    setSearchTerm = _b[1];
  var unassigned = getUnassignedLOB();
  var visibleOptions = useMemo(function () {
    return searchTerm.trim() ? options.filter(function (option) {
      return option.name.toLowerCase().includes(searchTerm.trim().toLowerCase());
    }) : options;
  }, [options, searchTerm]);
  var groupedOptions = useMemo(function () {
    var grouped = groupBy(visibleOptions, function (option) {
      return option.lobName || unassigned;
    });
    return Object.entries(grouped).sort(function (_a, _b) {
      var left = _a[0];
      var right = _b[0];
      return sortByLOBName({
        name: left,
        lobName: left
      }, {
        name: right,
        lobName: right
      }, unassigned);
    });
  }, [unassigned, visibleOptions]);
  var handleToggle = function (queueId) {
    onChange(value.includes(queueId) ? value.filter(function (id) {
      return id !== queueId;
    }) : __spreadArray(__spreadArray([], value, true), [queueId], false));
  };
  return _jsxs(Box, __assign({
    role: "group",
    "aria-label": ariaLabel
  }, {
    children: [_jsx(TextField, {
      placeholder: labels === null || labels === void 0 ? void 0 : labels.search,
      inputProps: {
        'aria-label': labels === null || labels === void 0 ? void 0 : labels.search
      },
      value: searchTerm,
      onChange: function (event) {
        return setSearchTerm(event.target.value);
      },
      size: "small",
      fullWidth: true,
      disabled: disabled,
      sx: {
        mb: 2
      }
    }), _jsx(StyledList, {
      children: groupedOptions.map(function (_a) {
        var lobName = _a[0],
          items = _a[1];
        return _jsxs(React.Fragment, {
          children: [_jsx(LobListSubheader, __assign({
            disableSticky: true
          }, {
            children: lobName
          })), items.map(function (option) {
            var checked = value.includes(option.uniqueId);
            var limitReached = maxSelected !== undefined && value.length >= maxSelected;
            return _jsx(ListItem, __assign({
              disablePadding: true
            }, {
              children: _jsx(FormGroup, __assign({
                row: true
              }, {
                children: _jsx(StyledFormControlLabel, {
                  control: _jsx(StyledCheckbox, {
                    checked: checked,
                    disabled: disabled || limitReached && !checked,
                    onChange: function () {
                      return handleToggle(option.uniqueId);
                    }
                  }),
                  label: option.name
                })
              }))
            }), option.uniqueId);
          })]
        }, lobName);
      })
    })]
  }));
});